// Single source of truth for top-level navigation tabs, filtered by the user's
// permission flags. Consumed by BubbleNav (and previously TopTabs). Icons are
// Material Symbols names. Tabs flagged `menu: true` are kept off the main bar
// and surfaced inside the profile menu instead (to save space on the bar).
export function buildTabs({ canAccessInbox, canAccessNfc, canApprove, canAccessTasks }) {
  return [
    { key: 'car-parts',       to: '/car-parts/home',        icon: 'directions_car', label: 'PAR Car Parts', match: ['/', '/car-parts'] },
    { key: 'client-tracking', to: '/client-tracking/map',   icon: 'map',            label: 'Client Tracking', match: ['/client-tracking'] },
    canAccessInbox && { key: 'support-inbox', to: '/support-inbox', icon: 'forum',  label: 'Support Inbox', match: ['/support-inbox'] },
    { key: 'profile-match',   to: '/profile-match/capture', icon: 'person_search',  label: 'Profile Match', match: ['/profile-match'] },
    canAccessTasks && { key: 'task-tracking', to: '/task-tracking', icon: 'checklist', label: 'Task Tracking', match: ['/task-tracking'] },
    canAccessNfc && { key: 'nfc-card', to: '/nfc-card',      icon: 'contact_mail',   label: 'NFC Business Card', match: ['/nfc-card'], menu: true },
    canApprove && { key: 'admin',      to: '/admin',         icon: 'settings',       label: 'Admin Dashboard', match: ['/admin'], menu: true }
  ].filter(Boolean);
}

export function activeTabIndex(tabs, pathname) {
  const idx = tabs.findIndex((t) =>
    t.match.some((m) => (m === '/' ? pathname === '/' : pathname === m || pathname.startsWith(m + '/')))
  );
  return idx === -1 ? 0 : idx;
}
